import { lazy } from "react";
import { getRoute } from "util/react";

export const NotAllowedRoute = getRoute(
  {
    fullPath: "/:locale?/auth/not-allowed",
  },
  "auth/not-allowed",
  lazy(() => import("./permissionDenied")),
  null,
);

export const LogoutRoute = getRoute(
  {
    fullPath: "/:locale?/auth/logout",
  },
  "auth/logout",
  lazy(() => import("./logout")),
  null,
);

export const ConfirmationRoute = getRoute(
  {
    fullPath: "/:locale?/auth/confirmation/:id",
  },
  "auth/confirmation/:id",
  lazy(() => import("./confirmation")),
  null,
);

export const LoginRoute = getRoute(
  {
    fullPath: "/:locale?/auth/login",
  },
  "auth/login",
  lazy(() => import("./index")),
  null,
);

export const RegisterRoute = getRoute(
  {
    fullPath: "/:locale?/auth/register",
  },
  "auth/register",
  lazy(() => import("./register")),
  null,
);

export const VerificationRoute = getRoute(
  {
    fullPath: "/:locale?/auth/verification",
  },
  "auth/verification",
  lazy(() => import("./verification")),
  null,
);

export const SetPhoneRoute = getRoute(
  {
    fullPath: "/:locale?/auth/set-phone",
  },
  "auth/set-phone",
  lazy(() => import("./setPhone")),
  null,
);

export const LostPasswordRoute = getRoute(
  {
    fullPath: "/:locale?/auth/lost-password",
  },
  "auth/lost-password",
  lazy(() => import("./lostPassword")),
  null,
);

export const ResetPasswordRoute = getRoute(
  {
    fullPath: "/:locale?/auth/reset-password",
  },
  "auth/reset-password",
  lazy(() => import("./resetPassword")),
  null,
);

export const MagicLinkRoute = getRoute(
  {
    fullPath: "/:locale?/auth/magic-link/:code",
  },
  "auth/magic-link/:code",
  lazy(() => import("./magicLink")),
  null,
);

const AuthRoute = (
  <>
    {RegisterRoute}
    {LoginRoute}
    {VerificationRoute}
    {SetPhoneRoute}
    {LostPasswordRoute}
    {ConfirmationRoute}
    {ResetPasswordRoute}
    {MagicLinkRoute}
    {LogoutRoute}
    {NotAllowedRoute}
  </>
);

export default AuthRoute;
